import { render, staticRenderFns } from "./material.vue?vue&type=template&id=a501f2e2&scoped=true&"
import script from "./material.vue?vue&type=script&lang=js&"
export * from "./material.vue?vue&type=script&lang=js&"
import style0 from "./material.vue?vue&type=style&index=0&id=a501f2e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a501f2e2",
  null
  
)

export default component.exports